import { ValidatorFn, AbstractControl, ValidationErrors } from "@angular/forms";

/** Custom Validator for Selectors on Dynamic Form */
export function isObjectValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const forbidden = typeof control.value != 'object';
      return forbidden ? {isObject: {value: control.value}} : null;
    };
}